import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Container, Button, Row, Card, Col, FloatingLabel, Form } from "react-bootstrap";

import { changeReconDate, getLastProcessService, loadReconData, loadReconDataService, resetReconData, saveReconService, selectAllReconData } from "../action/reconAction";
import { notification, warningNotification } from "../action/notificationAction";

import ReactTable from "./ReactTable";

import {
  setEnableMobileMenu
} from '../constant/constant';
import { formatAccounting, formatCurrency } from "../constant/format";
import DatePicker from "react-date-picker";

import { format } from 'date-fns';
import { loadSummaryReport, resetSummary } from "../action/reportAction";

export default function Recon({ permitted, minDate }) {

  const dispatch = useDispatch();

  const [reconDate, setReconDate] = React.useState(format(new Date(), "yyyy-MM-dd"));


  const reconData = useSelector(
    (state) => state.recon.reconData
  );

  const summary = useSelector(
    (state) => state.report.summary
  );

  const costcenter = useSelector(
    (state) => state.costcenter.costcenter
  );

  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    dispatch(resetReconData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [costcenter]);


  React.useEffect(() => {
    dispatch(setEnableMobileMenu(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (reconData && reconData.length > 0) {
      onProjectSelection();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reconData]);

  const search = () => {



    dispatch(resetSummary());
    dispatch(resetReconData());

    dispatch(loadSummaryReport(getSelectedProject(), null, reconDate, costcenter, true));
    dispatch(loadReconData(reconDate));

  }

  const onProjectSelection = () => {

    dispatch(loadSummaryReport(getSelectedProject(), null, reconDate, costcenter, true));

  }


  const getSelectedProject = () => {

    let projectId = null;

    if (reconData && reconData.length > 0) {
      projectId = reconData.filter(e => e.selected).map(e => {
        return e.id
      }).join(",")
    }

    return projectId && projectId !== '' ? projectId : null

  }

  const isAllSelected = () => {
    if (!reconData || reconData.length === 0) return false;
    return reconData.every(item => item.selected);
  }

  const handleSelectAll = () => {
    const selectAll = !isAllSelected();
    dispatch(selectAllReconData(selectAll));
  }

  const handleRecon = () => {

    const recon = {
      date: reconDate,
      profit: Number(summary?.profit),
      expense: (Number(summary.general ?? 0) + Number(summary.salary ?? 0) + Number(summary.tax ?? 0)),
      received: Number(summary.cpay),
      paid: Number(summary.vpay),
      projects_ids: getSelectedProject()
    }

    saveReconService(recon).then((res) => {
      dispatch(notification(res));

      dispatch(resetReconData());
      search();
    })
      .catch(err => {
        dispatch(notification(err))
      })
  }

  const theme = useSelector((state) => state.ThemeOptions);

  const columns = React.useMemo(
    () => [

      {
        Header: () => (
          <input
            type="checkbox"
            className="checkbox"
            checked={isAllSelected()}
            onChange={handleSelectAll}
            title="Select All / Unselect All"
          />
        ),
        accessor: (cell,) => {
          return (
            <input
              type="checkbox"
              className="checkbox"
              checked={cell['selected']}
              onChange={() => {
                dispatch(changeReconDate(cell['id']));
              }
              }
            />
          );
        },
        id: 'id'
      },
      {
        Header: 'Project Name',
        accessor: 'pname',
      },
      {
        Header: 'Sales',
        accessor: (cell) => formatCurrency(cell['sales']),
        className: "text-end"

      },
      {
        Header: 'Received',
        accessor: (cell) => formatCurrency(cell['received']),
        className: "text-end"
      }, {
        Header: 'Receivable',
        accessor: (cell) => formatCurrency(cell['rec'] ?? 0.00),
        className: "text-end"
      }, {
        Header: 'Sales UnAllocated',
        accessor: (cell) => formatCurrency(cell['salesAloc']),
        className: "text-end"
      }, {
        Header: 'Purchase',
        accessor: (cell) => formatCurrency(cell['purchase'] ?? 0.00),
        className: "text-end"
      }, {
        Header: 'Paid',
        accessor: (cell) => formatCurrency(cell['paid'] ?? 0.00),
        className: "text-end"
      }, {
        Header: 'Payable',
        accessor: (cell) => formatCurrency(cell['payable'] ?? 0.00),
        className: "text-end"
      }, {
        Header: 'Purchase UnAllocated',
        accessor: (cell) => formatCurrency(cell['purAloc'] ?? 0.00),
        className: "text-end"
      }],
    [reconData, dispatch]
  );

  return (
    <React.Fragment>
      <Container fluid >

        <Card>

          <Card.Header className={`d-flex ${theme.headerBackgroundColor}`}>
            <h6 className="text-start flex-fill">Summary  </h6>
            <div className="align-items-end ">
              <Button className="btn-alt" size="sm" onClick={handleRecon}>
                <i className="fa fa-download d-md-none d-sm-flex"></i>

                <p className="d-none d-md-inline" > Recon </p>
              </Button>
            </div>
          </Card.Header>

          <Card.Body>
            <Row className="mb-3 g-2">

              <Col sm={12} md={3}>
                <div style={{ position: "relative" }} className="dp">
                  <DatePicker maxDate={new Date()}
                    minDate={minDate ? new Date(minDate) : null}
                    id="reconDate"
                    value={reconData ? new Date(reconDate) : ""}

                    format="dd-MM-yyyy"
                    calendarIcon={<i className="fa fa-calendar"></i>}
                    clearIcon={null}
                    className={`form-control `}
                    //isInvalid={true}

                    onChange={(date) => setReconDate(format(date, "yyyy-MM-dd"))}
                  ></DatePicker>
                  <label className="black-text" htmlFor="reconDate">Recon Date</label>
                </div>

              </Col>

              <Col >
                <div className="d-grid flex-fill d-md-flex gap-2  justify-content-md-end  h-100 align-items-end">
                  <Button variant="success" size="sm" onClick={() => search()}>Search</Button>
                </div>
              </Col>

            </Row>
            <hr />
            <Row className="mb-3 g-2 justify-content-center">


              <Container fluid className="p-1">

                <Row className="mb-1 g-2">
                  <Col sm={12} md={6} lg={3} >

                    <Card>
                      <Card.Body className={`border border-${summary?.profit > 0 ? 'success' : 'danger'}`}>
                        <Card.Title className="text-center h6 mb-0">
                          <Row className={`${summary?.profit > 0 ? 'text-success' : 'text-danger'} p-2 `} style={{ fontSize: '1.2rem' }}>
                            <Col sm={12} md={9} className={`text-center fw-bold   border-end`} title="client.basic-(vendor.basic+expense)"> &#x20b9; {formatAccounting(summary ? summary.profit : 0)} </Col>
                            <Col sm={12} md={3} className={`text-center fw-bold  `}> {formatAccounting(summary ? summary.profitpercentage > 100 ? 100 : summary.profitpercentage < -100 ? -100 : summary.profitpercentage : 0)}% </Col>

                          </Row>
                        </Card.Title>
                        <Card.Subtitle className="text-muted text-center p-2 fw-bold" style={{ fontSize: '1rem' }}>Profit</Card.Subtitle>

                      </Card.Body>
                    </Card>

                  </Col>

                  <Col sm={12} md={6} lg={3}>

                    <Card className="border border-success">
                      <Card.Body>
                        <Card.Title className="h6" >
                          <Row className={`${summary?.coutstanding > 0 ? 'text-success' : 'text-danger'} m-1`}>
                            <Col className={`text-center fw-bold `}
                              title="Inclusive of tax-TDS-Received">
                              <i className="fa fa-arrow-circle-down pe-4 text-success"></i>
                              &#x20b9;
                              {formatAccounting(summary ? summary.coutstanding : 0)}</Col>
                          </Row>
                        </Card.Title>
                        <Card.Subtitle className="mb-1 text-muted text-center h7"> Client</Card.Subtitle>
                        <Row className="summary ml-auto"><Col xs={4}> Basic</Col> <u className={`col `}>  &#x20b9; {formatAccounting(summary ? summary.cbasic : 0)}</u> </Row>
                        <Row className="summary"><Col xs={4}> Tax</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.ctax : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Inclusive</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.cinclusive : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> TDS</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.ctds : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Return</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.cpayreturn : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Received</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.cpay : 0)}</Col> </Row>

                      </Card.Body>
                    </Card>

                  </Col>
                  <Col sm={12} md={6} lg={3} >

                    <Card className="border border-danger">
                      <Card.Body>

                        <Card.Title className="h6">
                          <Row className={`${summary?.voutstanding > 0 ? 'text-success' : 'text-danger'} m-1`}>
                            <Col className={`text-center fw-bold `}
                              title="Inclusive of tax-TDS-Paid"
                            >
                              <i className="fa fa-arrow-circle-up pe-4 text-danger"></i>
                              &#x20b9;
                              {formatAccounting(summary ? summary.voutstanding : 0)}</Col>
                          </Row>
                        </Card.Title>
                        <Card.Subtitle className="mb-1 text-muted text-center h7">Vendor</Card.Subtitle>

                        <Row className="summary"><Col xs={4}> Basic</Col> <u className={`col `}>  &#x20b9; {formatAccounting(summary ? summary.vbasic : 0)}</u> </Row>
                        <Row className="summary"><Col xs={4}> Tax</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.vtax : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Inclusive</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.vinclusive : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> TDS</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.vtds : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Return</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.vpayreturn : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Paid</Col> <Col> &#x20b9; {formatAccounting(summary ? summary.vpay : 0)}</Col> </Row>


                      </Card.Body>
                    </Card>

                  </Col>
                  <Col sm={12} md={4} lg={3}>

                    <Card className="border border-primary">
                      <Card.Body>

                        <Card.Title className="h6">
                          <Row className={`text-danger m-1`} title="General+Salary+GST">
                            <u className={`text-center fw-bold col `}>
                              <i className="fa fa-arrow-circle-up pe-4 text-danger"></i>
                              &#x20b9;
                              {formatAccounting(summary ? (Number(summary.general ?? 0) + Number(summary.salary ?? 0) + Number(summary.tax ?? 0)) : 0)}</u>
                          </Row>
                        </Card.Title>
                        <Card.Subtitle className="mb-1 text-muted text-center h7">Expense</Card.Subtitle>

                        <Row className="summary"><Col xs={4}> General</Col> <Col >  &#x20b9; {formatAccounting(summary ? summary.general : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Salary</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.salary : 0)}</Col> </Row>

                        <Row className="summary"><Col xs={4}> GST</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.tax : 0)}</Col> </Row>
                        <Row className="summary"><Col xs={4}> Wallet</Col> <Col > &#x20b9; {formatAccounting(summary ? summary.wallet : 0)}</Col> </Row>

                      </Card.Body>
                    </Card>

                  </Col>

                </Row>
              </Container>

              <Container fluid className="p-1">
                <ReactTable columns={columns} data={reconData} headerBackgroundColor={theme.headerBackgroundColor} >
                </ReactTable>
              </Container>

            </Row>

          </Card.Body>

        </Card>


      </Container>
      {/* <Confirm show={showConfirm} confirmation="Are you sure?" confirmCallBack={deletePayRequestOrder}></Confirm> */}
    </React.Fragment >);
}

// }
